import { Component, inject } from '@angular/core';
import { permissionOfRoute } from '@app/core/session/route-permission.util';
import { SessionStore } from '@app/core/session/session-store';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { PageHeaderComponent } from '@shared/components/page-header/page-header.component';
import { ActionCardComponent } from '@shared/ui/cards/action-card/action-card.component';

@Component({
  selector: 'app-home',
  imports: [PageHeaderComponent, ActionCardComponent, EmptyStateComponent],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent {
  private readonly sessionStore = inject(SessionStore);

  protected readonly userName = this.sessionStore.getSession()?.userName ?? '';

  protected readonly hasPermissions = this.sessionStore.hasAnyPermission();

  protected readonly canViewLeads = this.sessionStore.hasPermission(permissionOfRoute('/leads'));

  protected readonly canViewOpportunities = this.sessionStore.hasPermission(permissionOfRoute('/opportunities'));

  protected readonly canViewReports = this.sessionStore.hasPermission(permissionOfRoute('/report'));

  protected readonly canViewUsers = this.sessionStore.hasPermission(permissionOfRoute('/users'));
}
